import { render, staticRenderFns } from "./ProductPurchaseModal.vue?vue&type=template&id=161ca6c5&scoped=true"
import script from "./ProductPurchaseModal.vue?vue&type=script&lang=ts"
export * from "./ProductPurchaseModal.vue?vue&type=script&lang=ts"
import style0 from "./ProductPurchaseModal.vue?vue&type=style&index=0&id=161ca6c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ca6c5",
  null
  
)

export default component.exports